import { usePackageBookingStore } from "@elixir/stores";
import { PACKAGE_POPUP_TYPE } from "@elixir/types";
import { Drawer } from "antd";
import React from "react";
import CurrentTreatment from ".";
import { track } from "../../../../utils/tracking";

const CurrentTreatmentDrawer = () => {
  React.useEffect(() => {
    track("current_treatment_drawer_popup");
  }, []);

  const packagePopupType = usePackageBookingStore(
    (state) => state.packagePopupType
  );
  const setPackagePopupType = usePackageBookingStore(
    (state) => state.setPackagePopupType
  );
  const clearPackageDetails = usePackageBookingStore(
    (state) => state.clearPackageDetails
  );

  const handleCloseDrawer = () => {
    setPackagePopupType(PACKAGE_POPUP_TYPE.NONE);
    clearPackageDetails();
  };

  return (
    <Drawer
      style={{ padding: 0 }}
      bodyStyle={{ padding: 0 }}
      footer={null}
      width={"75%"}
      closable={false}
      placement={"right"}
      onClose={handleCloseDrawer}
      open={packagePopupType === PACKAGE_POPUP_TYPE.CURRENT_TREATMENT}
      extra={null}
    >
      <CurrentTreatment />
    </Drawer>
  );
};

export default CurrentTreatmentDrawer;
